import { get,post,getImage,postBlob,postMultipart } from "@/network/http";

//名字查询
export const getName = (params) => get("/qmnamet/qmNameT/list",params);
//访问记录查询
export const getDayAccess = (params) => get("/namedayaccesst/nameDayAccessT/list",params);
//付款信息查询
export const getNameMoney = (params) => get("/qmmoneyt/qmMoneyT/list",params);
//访问记录添加
export const dayAccessAdd = (params) => post("/namedayaccesst/nameDayAccessT/add",params);

//生成付款二维码
export const createTwoImage = (params) => post("/pay/CreateOrder",params);
//付款添加
export const moneyAdd = (params) => post("/qmmoneyt/qmMoneyT/add",params);

//查看当天多少人付款
export const getNumMoney = (params) => get("/qmmoneyt/qmMoneyT/num",params);



